(() => {
// Reference classifier for the light-choice panel (same rules as classify_reference.py, tested on 4,078 active+draft products).
// cls(value) -> 'C' | 'N' | 'F' | 'ALL' | 'DIM' | null
function acNorm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
const AC_ALL=/tricolor|tri-color|tricrom|tono y brillo|tono regulable|tonos regulables|3 colores|tres colores|3 tonos|tres tonos|3 cambios|tres cambios|cambio de (3 |tres )?colores?|cambio de color|colores cambia|3 luces intercambiables|intercambiable|cambiable|ajustable|cct|2700.?-?.?6500|3000.?k?.?(-|a|\/).?6000/;
const AC_DIM=/regulab|atenua|dimm|regulacion|regulador|sin escalas/;
function acLightClass(v){
  const n=acNorm(v);
  if(AC_ALL.test(n)) return 'ALL';
  const tones=[/calid|amarill/,/neutr|natural|universal/,/\bfri[oa]\b|diurna/].filter(r=>r.test(n)).length;
  if(tones>=2) return 'ALL';
  const ks=/\d\s?k\b/.test(n)?[...n.matchAll(/(?<!\d)([2-7]\d{3})(?!\d)/g)].map(m=>+m[1]).filter(k=>k>=2000&&k<=7500):[];
  if(ks.length){const k=ks.reduce((a,b)=>a+b,0)/ks.length; return k<=3500?'C':(k<5000?'N':'F');}
  if(/calid|amarill/.test(n)) return 'C';
  if(/neutr|natural|universal/.test(n)) return 'N';
  if(/\bfri[oa]\b|diurna|luz blanca|iluminacion blanca|blanco blanco|blanco puro|monocromatica/.test(n)) return 'F';
  if(AC_DIM.test(n)) return 'DIM';
  return null;
}
// An option is a light choice when its values give >= 2 different classes (any option name).
// v64: at least one value must carry a strong light signal, so finish options ("Madera natural") never trigger the panel.
const AC_STRONG=/calid|fri[oa]\b|neutr|tricolor|\d\s?k\b|\bluz\b|luces|tonos|colores|cambio|tricrom|cct/;
function acIsLightOption(values){const s=new Set(values.map(acLightClass).filter(Boolean)); return s.size>=2 && values.some(v=>AC_STRONG.test(acNorm(v)));}
// Regulable note: selected value matches AC_DIM (also when it is e.g. 'Blanco cálido regulable').
function acIsDimmable(v){return AC_DIM.test(acNorm(v));}


  const normalizeLabel = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g, ' ').trim().replace(/:$/, '').trim().toLocaleLowerCase('es');
  const technicalLabels = new Set(`material|materiales|materia prima|materia de pantalla|material de fijación|material de la pantalla|voltaje|tensión|dimensiones|medidas|tamaño|ancho|anchura|altura|alto|fondo|profundidad|diámetro|diámetro de la base|diámetro de la pantalla|longitud del cable|longitud de cable|longitud de la cadena|altura ajustable|altura de suspensión|cadena/cable ajustable o no|peso|peso neto|peso del producto|fuente de luz|tipo de luz|luz|color de luz|color de la luz|temperatura de color|temperatura de la luz|flujo luminoso|lúmenes|potencia|potencia máx.|potencia máxima|potencia de la luz|potencia del motor|consumo eléctrico|fuente de energía|fuente de alimentación|conexión|tipo de conexión|instalación|tipo de instalación|montaje|requiere montaje|requiere ensamblaje|clasificación ip|protección|protección ip|grado ip|grado de protección|índice de protección|base de bombilla|base de la bombilla|tipo de base|tipo de base de la fuente de luz|casquillo|tipo de bombilla|número de bombillas|número de bombilla|número de luces|bombilla incluida|bombillas incluidas|regulable|atenuable|interruptor|control|método de control|colores disponibles|colores|color|acabado|acabados|estilo|uso|uso interior o exterior|ubicación|área de iluminación|superficie iluminada|superficie recomendada|estancia adecuada sugerida|tamaño sugerido de la habitación|irc|cri|vida útil|motor|velocidades|sentido de giro|nivel de ruido|ventilador|requisitos de techo|florón (base de techo)|base|pantalla|contenido del paquete|contenido de la caja|incluido en la caja|sensor|rango de temperatura operativa|bombilla|alimentación|dimensión|capacidad de batería|capacidad batería|batería|clase|clase eléctrica|clase de protección|class|cargador|tiempo de carga|autonomía|ángulo de apertura|resistencia a la humedad|compatibilidad|capacidad|garantía|certificación|certificaciones|diseño|tipo de base de bombilla|clasificación de humedad|color del cuerpo|altura total de la lámpara|base de montaje|diámetro del globo|modelos disponibles`.split('|').map(normalizeLabel));
  const marketingLabel = label => /^(por que|beneficios|ventajas|diseno (?:elegante|moderno|minimalista|atemporal|unico)|materiales de alta calidad|iluminacion (?:eficiente|agradable)|estilo versatil|versatilidad|ambiente|ocasiones|facil mantenimiento|facil instalacion)/.test(normalizeLabel(label));
  function bulletSpec(text, technical = false) {
    const colon = text.indexOf(':');
    if (colon < 1) return null;
    const label = text.slice(0, colon).replace(/\s+/g, ' ').trim().replace(/^[•·]\s*/, '');
    const value = text.slice(colon + 1).trim();
    return !marketingLabel(label) && (technical || label.length <= 70) && value && (technical || technicalLabels.has(normalizeLabel(label))) ? {label, value, colon} : null;
  }
  const technicalHeading = text => /^(especificaciones(?: tecnicas)?(?: del producto)?|caracteristicas tecnicas(?: del producto)?|detalles tecnicos(?: del producto)?|datos tecnicos|ficha tecnica)[:.]?$/.test(text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toLocaleLowerCase('es'));
  const marketingHeading = text => /^(por que|beneficios|ventajas|lo que hace|caracteristicas (?:principales|destacadas)|por que nos gusta)/.test(normalizeLabel(text));
  const sizeContext = text => /^\d+(?:[.,]\d+)?\s*(?:cm|mm|m)(?:\s*[x×]\s*\d+(?:[.,]\d+)?\s*(?:cm|mm|m)?)*$/i.test(text.trim());
  const directItemText = item => [...item.childNodes].filter(node => !['UL','OL'].includes(node.tagName)).map(node => node.textContent).join('');
  function listSpec(item) {
    if (item.querySelector('ul,ol,table') || item.closest('table')) return null;
    let list = item.parentElement, technical = false;
    const context = [];
    while (list) {
      let heading = list.previousElementSibling;
      while (heading?.tagName === 'BR') heading = heading.previousElementSibling;
      if (heading && marketingHeading(heading.textContent)) return null;
      if (heading && technicalHeading(heading.textContent)) technical = true;
      const parent = list.parentElement;
      if (parent?.tagName !== 'LI') break;
      const text = directItemText(parent).trim();
      const colon = text.indexOf(':');
      if ((colon > 0 && !text.slice(colon + 1).trim()) || (colon < 0 && (technicalLabels.has(normalizeLabel(text)) || sizeContext(text)))) {
        const label = colon < 0 ? text : text.slice(0, colon).trim();
        context.unshift(label);
        if (technicalLabels.has(normalizeLabel(label)) || sizeContext(label)) technical = true;
      }
      list = parent.parentElement;
    }
    const parsed = bulletSpec(item.textContent, technical) || (technical && context.length && !item.textContent.includes(':') && item.textContent.trim() ? {label:context.join(' · '),value:item.textContent.trim(),colon:-1} : null);
    if (parsed && context.length && parsed.colon >= 0) parsed.context = context.join(' · ');
    return parsed;
  }
  function paragraphLines(paragraph) {
    const lines = [document.createDocumentFragment()];
    function append(node, path) {
      let target = lines[lines.length - 1];
      for (const ancestor of path) { const wrapper = ancestor.cloneNode(false); wrapper.removeAttribute('style'); target.append(wrapper); target = wrapper; }
      target.append(node);
    }
    function visit(node, path) {
      if (node.nodeType === 3) {
        const parts = node.textContent.split(/\n|(?=[•·]\s*(?:[A-Za-zÁÉÍÓÚÜÑáéíóúüñ][^•·:\n]{0,70}):)/);
        parts.forEach((part,index) => { if (index) lines.push(document.createDocumentFragment()); if (part) append(document.createTextNode(part),path); });
      } else if (node.tagName === 'BR') lines.push(document.createDocumentFragment());
      else if (!node.childNodes.length) append(node.cloneNode(true),path);
      else for (const child of node.childNodes) visit(child,[...path,node]);
    }
    for (const node of paragraph.childNodes) visit(node,[]);
    return lines.filter(line => line.textContent.trim());
  }
  function contentAfter(container, offset) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) { if (offset <= node.textContent.length) break; offset -= node.textContent.length; }
    if (!node) return document.createDocumentFragment();
    const range = document.createRange(); range.selectNodeContents(container); range.setStart(node,offset); return range.cloneContents();
  }
  const emptySpecValue = text => !text.replace(/\u00a0/g,' ').trim() || /^(?:[\/\\|\-–—_.]+|n\/?a|n\.?d\.?|null|undefined)$/i.test(text.trim());
  function normalizeSpecifications(source, specs) {
    for (const stylesheet of source.querySelectorAll('style')) stylesheet.remove();
    source.removeAttribute('style');
    for (const element of source.querySelectorAll('*')) element.removeAttribute('style');
    const table = document.createElement('table');
    table.className = 'bv5-spec-table';
    table.setAttribute('aria-label', 'Características técnicas');
    const body = document.createElement('tbody');
    let preservedRows = 0;
    const labelRows = new Map();
    const columns = document.createElement('colgroup');
    columns.append(document.createElement('col'), document.createElement('col'));
    table.append(columns, body);
    const appendRow = (label, content) => {
      const cleanText = content.textContent.replace(/\s+/g,' ').trim();
      if (emptySpecValue(cleanText)) return;
      for (const element of content.querySelectorAll('*')) element.removeAttribute('style');
      const key = normalizeLabel(label);
      const existing = labelRows.get(key);
      if (existing) {
        if (!existing.values.has(cleanText)) { existing.cell.append(document.createElement('br'),content); existing.values.add(cleanText); }
        return;
      }
      const row = document.createElement('tr');
      const heading = document.createElement('th');
      heading.scope = 'row';
      heading.textContent = label;
      const value = document.createElement('td');
      value.append(content);
      row.append(heading, value);
      body.append(row);
      labelRows.set(key,{cell:value,values:new Set([cleanText])});
    };
    const removeEmptyContainer = node => {
      if (node.querySelector('tr,li')) return;
      const previous = node.previousElementSibling;
      if (previous && technicalHeading(previous.textContent)) previous.remove();
      node.remove();
    };
    const cloneContents = cell => {
      const fragment = document.createDocumentFragment();
      for (const child of cell.childNodes) fragment.append(child.cloneNode(true));
      return fragment;
    };
    const appendSection = label => {
      const row = document.createElement('tr');
      row.className = 'bv5-spec-section';
      const heading = document.createElement('th');
      heading.colSpan = 2;
      heading.textContent = label;
      row.append(heading);
      body.append(row);
    };
    let sectionLabel = '';
    for (const old of [...source.querySelectorAll('table')]) {
      if (!source.contains(old)) continue;
      const sourceRows = [...old.querySelectorAll('tr')].filter(row => row.closest('table') === old);
      const ordinary = sourceRows.every(row => {
        const cells = [...row.children].filter(cell => /^(TD|TH)$/.test(cell.tagName));
        return cells.length <= 2 && cells.every(cell => cell.rowSpan <= 1 && !cell.querySelector('table'));
      });
      const headingsOnly = sourceRows.length && sourceRows.every(row => [...row.children].every(cell => cell.tagName === 'TH'));
      if (!ordinary || headingsOnly) {
        old.classList.add('bv5-spec-table');
        old.dataset.bv5PreservedStructure = 'true';
        if (!old.hasAttribute('aria-label') && !old.hasAttribute('aria-labelledby') && !old.querySelector('caption')) old.setAttribute('aria-label', 'Características técnicas');
        for (const node of [old, ...old.querySelectorAll('table,tr,td,th,col,colgroup,thead,tbody,tfoot')]) {
          node.removeAttribute('style');
          node.removeAttribute('width');
          node.removeAttribute('height');
          node.removeAttribute('cellpadding');
          node.removeAttribute('cellspacing');
        }
        for (const node of old.querySelectorAll('*')) node.removeAttribute('style');
        preservedRows += sourceRows.length;
        specs.append(old);
        continue;
      }
      for (const row of sourceRows) {
        const cells = [...row.children].filter(cell => /^(TD|TH)$/.test(cell.tagName));
        if (!cells.length || !cells.some(cell => cell.textContent.trim())) { row.remove(); continue; }
        if (cells.length === 2 && !cells.every(cell => cell.tagName === 'TH') && cells[0].textContent.trim() && emptySpecValue(cells[1].textContent)) { row.remove(); continue; }
        if (cells.length === 2 && cells.every(cell => cell.tagName === 'TH')) {
          sectionLabel = cells.map(cell => cell.textContent.trim()).join(' · ');
          appendSection(sectionLabel);
        } else if (cells.length === 2 && (technicalHeading(cells[0].textContent) || normalizeLabel(cells[0].textContent) === 'medidas') && /^(caracteristica|caracteristicas|diseno)$/.test(normalizeLabel(cells[1].textContent))) {
          sectionLabel = cells[0].textContent.trim(); appendSection(sectionLabel);
          sectionLabel = cells[1].textContent.trim(); appendSection(sectionLabel);
        } else if (cells.length === 2 && cells[1].textContent.trim()) {
          const label = cells[0].textContent.replace(/\s+/g,' ').trim().replace(/:$/, '').trim() || sectionLabel || 'Características técnicas';
          if (marketingLabel(label)) { const prose = document.createElement('p'); const strong = document.createElement('strong'); strong.textContent = label + ': '; prose.append(strong,cloneContents(cells[1])); old.parentElement.insertBefore(prose,old); }
          else appendRow(label, cloneContents(cells[1]));
        } else {
          const cell = cells.find(cell => cell.textContent.trim());
          const text = cell.textContent.replace(/\s+/g,' ').trim();
          const isHeading = cell.tagName === 'TH' || (text.length <= 100 && (cell.querySelector('strong,b') || technicalLabels.has(normalizeLabel(text)) || /^(caracteristica|caracteristicas|informacion de la bombilla|peso & tamano|contenido del paquete|nota|diseno)$/.test(normalizeLabel(text))));
          if (isHeading) { sectionLabel = text; appendSection(text); }
          else appendRow(sectionLabel || 'Características técnicas', cloneContents(cell));
        }
        row.remove();
      }
      if (!old.querySelector('tr')) removeEmptyContainer(old);
    }
    let listPasses = 0, listChanges;
    do {
      listChanges = 0;
    for (const item of [...source.querySelectorAll('ul > li')]) {
      const parsed = listSpec(item);
      if (!parsed) continue;
      appendRow(parsed.context ? parsed.context + ' · ' + parsed.label : parsed.label, contentAfter(item,parsed.colon + 1));
      listChanges += 1;
      const list = item.parentElement;
      item.remove();
      let emptyList = list;
      while (emptyList && !emptyList.querySelector('li')) {
        const parentItem = emptyList.parentElement?.tagName === 'LI' ? emptyList.parentElement : null;
        removeEmptyContainer(emptyList);
        if (!parentItem || parentItem.querySelector('ul,ol') || !(technicalLabels.has(normalizeLabel(parentItem.textContent)) || sizeContext(parentItem.textContent) || /^[^:]+:\s*$/.test(parentItem.textContent))) break;
        const outerList = parentItem.parentElement;
        parentItem.remove();
        emptyList = outerList;
      }
    }
    } while (listChanges && ++listPasses < 20);
    for (const paragraph of [...source.querySelectorAll('p')]) {
      if (!source.contains(paragraph) || paragraph.closest('li,table')) continue;
      let previous = paragraph.previousElementSibling, technical = false;
      while (previous && previous.tagName === 'P') { if (technicalHeading(previous.textContent)) { technical = true; break; } previous = previous.previousElementSibling; }
      if (previous && technicalHeading(previous.textContent)) technical = true;
      const lines = paragraphLines(paragraph);
      const inlineBullets = /[•·]/.test(paragraph.textContent);
      if ((!technical && !inlineBullets) || lines.length < 2) continue;
      let label = '', group = '', moved = false;
      const remaining = [];
      for (const line of lines) {
        const text = line.textContent.trim().replace(/^[•·]\s*/, '');
        const colon = text.indexOf(':');
        if (colon > 0 && !text.slice(colon + 1).trim() && !marketingLabel(text.slice(0,colon)) && (technical || technicalLabels.has(normalizeLabel(text.slice(0,colon))))) {
          const nextLabel = text.slice(0,colon).trim();
          if (normalizeLabel(nextLabel) === 'modelos disponibles') { group = nextLabel; label = ''; }
          else label = group ? group + ' · ' + nextLabel : nextLabel;
          continue;
        }
        if (colon > 0 && marketingLabel(text.slice(0,colon))) { remaining.push(line); continue; }
        const parsed = bulletSpec(text, technical);
        if (parsed) {
          const originalColon = line.textContent.indexOf(':');
          appendRow(label ? label + ' · ' + parsed.label : parsed.label,contentAfter(line,originalColon + 1)); moved = true;
        } else if (label && colon < 0 && !marketingLabel(label)) {
          appendRow(label,contentAfter(line,line.textContent.search(/\S/))); moved = true;
        } else remaining.push(line);
      }
      if (moved) {
        if (remaining.length) { paragraph.replaceChildren(); remaining.forEach((line,index) => { if (index) paragraph.append(document.createElement('br')); paragraph.append(line); }); }
        else paragraph.remove();
      }
    }
    for (const heading of [...source.querySelectorAll('h2,h3,h4,h5,h6,p')]) {
      if (!technicalHeading(heading.textContent)) continue;
      let next = heading.nextElementSibling;
      while (next && !next.textContent.trim() && !next.querySelector('img,video,iframe,svg,picture')) { const following = next.nextElementSibling; next.remove(); next = following; }
      const contextOnly = next?.tagName === 'UL' && [...next.querySelectorAll('li')].every(item => /^(ambiente|ocasiones)$/.test(normalizeLabel(directItemText(item).split(':')[0])));
      if (!next || contextOnly) heading.remove();
    }
    if (body.children.length) specs.append(table);
    return body.children.length + preservedRows;
  }
  function init(root) {
    if (root.dataset.bv5Ready) return;
    root.dataset.bv5Ready = 'true';
    const source = root.querySelector('[data-bv5-source]');
    const specs = root.querySelector('[data-bv5-specs]');
    if (source) {
      source.querySelectorAll('img, picture, figure').forEach(node => node.remove());
      source.querySelectorAll('p').forEach(node => {
        if (!node.textContent.replace(/[\s\u00a0\u200b]/g, '') && !node.querySelector('video, iframe, svg, object, audio')) node.remove();
      });
    }
    if (source && specs) {
      root.dataset.bv5SourceTables = String(source.querySelectorAll('table').length);
      root.dataset.bv5SourceSpecBullets = String([...source.querySelectorAll('ul > li')].filter(item => listSpec(item)).length);
      root.dataset.bv5NormalizedRows = String(normalizeSpecifications(source, specs));
    }
    const panels = [...root.querySelectorAll('.bv5-info')];
    const links = [...root.querySelectorAll('[data-bv5-tab]')];
    const mq = matchMedia('(max-width: 700px)');
    function select(id) {
      for (const p of panels) { const active = p.id === id; p.classList.toggle('selected',active); if (active) p.open = true; }
      for (const a of links) { if (a.hash === '#' + id) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); }
    }
    function syncLayout() {
      if (mq.matches) {
        for (const panel of panels) panel.open = panel.classList.contains('selected');
      } else {
        const active = panels.find(panel => panel.classList.contains('selected')) || panels[0];
        if (active) select(active.id);
      }
    }
    function syncSpecifications() {
      for (const cell of specs?.querySelectorAll('.bv5-spec-table td') || []) {
        cell.classList.toggle('bv5-spec-value--long', cell.textContent.replace(/\s+/g, ' ').trim().length > 80);
      }
      for (const row of specs?.querySelectorAll('.astro-facts dl > div') || []) { const value = row.querySelector('dd'); if (value && emptySpecValue(value.textContent)) row.remove(); }
      for (const facts of specs?.querySelectorAll('.astro-facts') || []) if (!facts.querySelector('dl > div')) facts.remove();
      const detailsPanel = specs?.closest('.bv5-info');
      const detailsLink = detailsPanel && links.find(link => link.hash === '#' + detailsPanel.id);
      const hasSpecs = !!specs?.querySelector('.bv5-spec-table th[scope="row"], .bv5-spec-table[data-bv5-preserved-structure] td, .bv5-spec-table[data-bv5-preserved-structure] th, .astro-facts dl > div');
      if (detailsPanel) detailsPanel.hidden = !hasSpecs;
      if (detailsLink) detailsLink.hidden = !hasSpecs;
      document.querySelectorAll('.bv5-measures-link').forEach(link=>link.hidden=!hasSpecs);
      specs?.querySelector('.bv5-specs-fallback')?.remove();
      if (!hasSpecs && detailsPanel?.classList.contains('selected')) {
        const description = panels.find(panel => panel.querySelector('[data-bv5-source]'));
        if (description) select(description.id);
      }
      syncFaq(root);
      return hasSpecs;
    }
    root.bv5SyncSpecifications = syncSpecifications;
    const hasSpecs = syncSpecifications();
    const initial = hasSpecs ? specs?.closest('.bv5-info') : panels.find(panel => panel.querySelector('[data-bv5-source]'));
    if (initial) select(initial.id);
    syncLayout();
    mq.addEventListener('change', syncLayout);
    for (const a of links) a.addEventListener('click',e=>{e.preventDefault();select(a.hash.slice(1));if(mq.matches)root.querySelector(a.hash)?.scrollIntoView({block:'start'});});
    for (const button of root.querySelectorAll('[data-bv5-reel-scroll]')) button.addEventListener('click',()=>root.querySelector('[data-bv5-reels]')?.scrollBy({left:Number(button.dataset.bv5ReelScroll)*480,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
  }
  function setFaqLead(paragraph, lead, rest) {
    if (!paragraph) return;
    const strong = document.createElement('strong');
    strong.textContent = lead;
    paragraph.replaceChildren(strong, document.createTextNode(rest ? ' ' + rest : ''));
  }
  function syncFaq(root) {
    const service = [...document.querySelectorAll('[data-bv5-service]')].find(node => node.dataset.productId === root.dataset.productId);
    if (!service) return;
    const rows = [...root.querySelectorAll('.bv5-spec-table tr')].map(row => ({label: normalizeLabel(row.querySelector('th[scope="row"]')?.textContent || ''), value: row.querySelector('td')?.textContent.replace(/\s+/g,' ').trim() || ''}));
    for (const row of root.querySelectorAll('.astro-facts dl > div')) rows.push({label:normalizeLabel(row.querySelector('dt')?.textContent || ''),value:row.querySelector('dd')?.textContent.trim() || ''});
    const bulb = rows.find(row => ['bombilla','bombilla incluida','fuente de luz','tipo de luz'].includes(row.label) && row.value);
    const bulbAnswer = service.querySelector('[data-bv5-faq-bulb] p');
    setFaqLead(bulbAnswer, bulb ? 'Fuente de luz: ' + bulb.value.replace(/[.\s]+$/,'') + '.' : 'Depende del modelo:', bulb ? 'Lo verás también en las características técnicas.' : 'en las características técnicas verás si lleva LED integrado o si necesita bombilla.');
    const ipRows = rows;
    const ipMatches = [...(ipRows.map(row => row.value).join(' ') + ' ' + [...root.querySelectorAll('.bv5-spec-table td, .bv5-spec-table th')].map(cell=>cell.textContent).join(' ') + ' ' + (service.dataset.ipTags || '')).matchAll(/\bIP\s*(\d{2})\b/gi)].map(match => Number(match[1]));
    const unique = [...new Set(ipMatches)];
    const ip = unique.length === 1 ? unique[0] : null;
    const usage = ip >= 44 && ip <= 54 ? 'zonas con salpicaduras, como el baño o un porche cubierto' : ip >= 55 ? 'exterior, también expuesta a la lluvia' : null;
    const ipQuestion = service.querySelector('[data-bv5-faq-ip]');
    if (ipQuestion) {ipQuestion.hidden = !usage; ipQuestion.dataset.ipStatus = !unique.length ? 'missing' : unique.length > 1 ? 'multiple-unmapped' : usage ? 'mapped' : 'range-unmapped'; if (usage) setFaqLead(ipQuestion.querySelector('p'), `Sí, tiene protección IP${ip}`, `para ${usage}.`);}
    const installation = document.querySelector(`[data-bv5-target-part="installation"] [data-installation-mode]`);
    const mode = installation?.dataset.installationMode || service.dataset.installationMode || 'fixed';
    const installQuestion = service.querySelector('[data-bv5-faq-installation]');
    if (installQuestion) {installQuestion.hidden = false; const ready = ['ready','cordless'].includes(mode); setFaqLead(installQuestion.querySelector('p'), ready ? 'No.' : 'Sí, te recomendamos un electricista.', ready ? 'Esta lámpara se enchufa o funciona con batería: no necesita instalación.' : 'Es una instalación sencilla y rápida para las lámparas con conexión fija (techo, colgantes, apliques y ventiladores).');}
  }
  let lightController;
  function connectLightChoice() {
    const area = document.querySelector('.astroclaro-pdp .product-info');
    if (!area) return;
    if (lightController?.area === area) {lightController.reconcile();return;}
    lightController?.observer.disconnect();
    let options=[];
    try {options=JSON.parse(area.querySelector('[data-bv5-light-options]')?.textContent||'[]');} catch {}
    const option=options.find(item=>acIsLightOption(item.values));
    const note=document.querySelector('[data-bv5-light-option-note]');
    if (note) {
      note.hidden = !option;
      note.replaceChildren();
      if (option) {
        const strong = document.createElement('strong'); strong.textContent = option.name;
        note.append('Elige la luz de este modelo en ', strong, '.');
      }
    }
    if(!option) return;
    const panel=document.createElement('div');panel.className='bv5-light-choice';panel.dataset.bv5LightPanel='true';
    panel.setAttribute('role','note');panel.setAttribute('aria-label',`Guía de ${option.name}`);
    panel.innerHTML='<div class="bv5-light-rows"><div data-light-class="C"><i></i><strong>Cálida</strong><span>2700–3000 K</span><span>Ambiente acogedor</span></div><div data-light-class="N"><i></i><strong>Neutra</strong><span>4000–4500 K</span><span>Cocina y baño</span></div><div data-light-class="F"><i></i><strong>Fría</strong><span>6000–6500 K</span><span>Trabajo y estudio</span></div></div><p data-light-dimmable hidden>Regulable: ajustas la intensidad de la luz.</p>';
    let current=option.selected,host,pressedAt;
    const paint=value=>{
      current=value;const cls=acLightClass(value);
      panel.querySelectorAll('[data-light-class]').forEach(row=>row.classList.toggle('is-selected',cls==='ALL'||row.dataset.lightClass===cls));
      panel.querySelector('[data-light-dimmable]').hidden=!acIsDimmable(value);
    };
    const nativeHost=()=>area.querySelector(`[data-bv5-option-position="${option.position}"]`);
    const swatchHost=()=>[...area.querySelectorAll('.swatch-single')].find(group=>group.querySelector('.swatch-option-name')?.textContent.trim().replace(/:$/,'')===option.name);
    const observer=new MutationObserver(()=>reconcile(false));
    const reconcile=(server=true)=>{
      const native=nativeHost(),swatch=swatchHost();
      const next=swatch?.getBoundingClientRect().height?swatch:native;
      if(!next)return;
      if(host!==next){observer.disconnect();host=next;}
      if(panel.parentNode!==host){observer.disconnect();host.append(panel);}
      if(server){let variant;try{variant=JSON.parse(area.querySelector('variant-picker [data-variant]')?.textContent||'{}');}catch{};paint(variant?.options?.[option.position-1]||current);}
      observer.observe(host,{childList:true});
    };
    const immediate=event=>{
      const target=event.target.closest('[role="radio"],input[type="radio"],label,select,option');
      if(!target)return;
      const group=target.closest('.swatch-single'),field=target.closest('[data-bv5-option-position]');
      if(group!==swatchHost() && Number(field?.dataset.bv5OptionPosition)!==option.position)return;
      const value=[target.getAttribute('orig-value'),target.getAttribute('aria-label'),target.dataset.bv5OptionValue,target.querySelector('[data-bv5-option-value]')?.dataset.bv5OptionValue,target.value,target.labels?.[0]?.textContent.trim(),target.control?.dataset.bv5OptionValue,target.textContent.trim()].find(candidate=>option.values.includes(candidate));
      if(option.values.includes(value)) {reconcile(false);paint(value);panel.dataset.lastImmediateValue=value;if(event.type==='click' && pressedAt!=null){panel.dataset.highlightDelayMs=(performance.now()-pressedAt).toFixed(2);panel.dataset.highlightClock='pointerdown-to-highlight';pressedAt=null;}}
    };
    area.addEventListener('pointerdown',()=>{pressedAt=performance.now();},true);area.addEventListener('click',immediate,true);area.addEventListener('change',immediate,true);
    const form=document.querySelector('.astroclaro-pdp form[is="product-form"]');
    form?.addEventListener('product:rerender',()=>{reconcile();queueMicrotask(()=>reconcile());});
    form?.addEventListener('variant:change',()=>reconcile());
    window.addEventListener('load',()=>reconcile(false),{once:true});
    lightController={area,observer,reconcile};paint(current);reconcile();
  }
  function connectPageActions() {
    if (!document.documentElement.dataset.bv5Actions) {
      document.documentElement.dataset.bv5Actions = 'true';
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-bv5-open]');
        if (!link) return;
        const root = document.querySelector('[data-bv5-content]');
        const kind = link.dataset.bv5Open;
        let target;
        if (kind === 'variants') target = [...document.querySelectorAll('.astroclaro-pdp .product-info__variant-picker, .astroclaro-pdp .swatch-single')].find(node => node.getBoundingClientRect().height > 0) || document.querySelector('.astroclaro-pdp .bv5-buy-row');
        else target = root?.querySelector(kind === 'specs' ? '[data-bv5-specs]' : '[id^="bv5-shipping-"]');
        if (!target) return;
        const panel = target.closest('.bv5-info');
        if (panel?.hidden) return;
        event.preventDefault();
        if (panel) {const tab = root.querySelector(`[data-bv5-tab][href="#${panel.id}"]`); tab?.click(); panel.open = true; target = panel;}
        target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        const focus = kind === 'variants' ? (target.querySelector('[role="radio"]') || target.querySelector('input:not([type="hidden"]),button,select')) : panel?.querySelector('summary');
        focus?.focus({preventScroll:true});
      });
    }
    for (const player of document.querySelectorAll('[data-bv5-film]')) {
      if (player.dataset.ready) continue;
      player.dataset.ready = 'true';
      const video = player.querySelector('video'), button = player.querySelector('button');
      const loadPoster = () => { if (video.dataset.lazyPoster) {video.poster = video.dataset.lazyPoster; delete video.dataset.lazyPoster;} };
      if ('IntersectionObserver' in window) {const observer = new IntersectionObserver(entries => {if (entries.some(entry => entry.isIntersecting)) {loadPoster(); observer.disconnect();}}, {rootMargin:'200px'}); observer.observe(player);} else loadPoster();
      button.addEventListener('click', () => {loadPoster(); video.play().catch(() => {button.hidden = false;});});
      video.addEventListener('play', () => {button.hidden = true;});
      video.addEventListener('pause', () => {button.hidden = false;});
      video.addEventListener('ended', () => {button.hidden = false;});
    }
  }
  function connectVariantUpdates() {
    const form = document.querySelector('.astroclaro-pdp form[is="product-form"]');
    if (!form || form.dataset.bv5DetailBound) return;
    form.dataset.bv5DetailBound = 'true';
    form.addEventListener('product:rerender', event => {
      if (event.detail?.productChange) { window.location.reload(); return; }
      const fragment = event.detail?.htmlFragment;
      if (!fragment) return;
      for (const target of document.querySelectorAll('[data-bv5-target-part]')) {
        const source = fragment.querySelector(`template[data-bv5-source-part="${target.dataset.bv5TargetPart}"]`);
        if (source) target.replaceChildren(source.content.cloneNode(true));
      }
      document.querySelectorAll('[data-bv5-content]').forEach(root => root.bv5SyncSpecifications?.());
      queueMicrotask(connectVariantUpdates);
    });
  }
  function hydrateDecisionParts(fragment=document) {
    for(const target of document.querySelectorAll('[data-bv5-target-part]')) {const source=fragment.querySelector(`template[data-bv5-source-part="${target.dataset.bv5TargetPart}"]`);if(source)target.replaceChildren(source.content.cloneNode(true));}
  }
  const run = () => {hydrateDecisionParts();connectLightChoice();document.querySelectorAll('[data-bv5-content]').forEach(init);connectVariantUpdates();connectPageActions();};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
  document.addEventListener('shopify:section:load',run);
})();
